import axios from 'axios'
import { scanStaticFiles, prefetch } from './prefetch'
import { getLocalStorage } from '@voghion/fe-util'

const autoRefreshKey = 'auto_refresh_page'

/**
 * 通过对入口页面发起请求让页面缓存失效
 */
function resetEntryCache() {
  return new Promise((resolve) => {
    const isIframe = window.parent !== window
    if (isIframe) {
      // chrome 无法通过 xhr 更新 iframe 的页面，通过缓存标识页面需要刷新
      const storage = getLocalStorage()
      storage.setItem(autoRefreshKey, '1')
      resolve(true)
    } else {
      const currentUrl = location.href.split('#')[0]
      axios
        .get(currentUrl, {
          method: 'GET',
          responseType: 'text',
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then(
          async (res) => {
            if (res.status === 200 && res.data) {
              // 预加载新的资源
              const staticTasks = []
              if (!isIframe) {
                staticTasks.push(prefetch(currentUrl))
              }
              const content = res.data
              if (content.includes('</html>')) {
                const arr = currentUrl.split('/')
                arr.pop()
                const staticFiles = await scanStaticFiles(content, arr.join('/'))
                for (const url of staticFiles.scripts.concat(staticFiles.styles).concat(staticFiles.others)) {
                  staticTasks.push(prefetch(url, false, staticFiles.isModule && !url.includes('legacy')))
                }
              }
              return Promise.all(staticTasks).then(resolve)
            } else {
              resolve(true)
            }
          },
          () => {
            resolve(true)
          }
        )
    }
  })
}

/**
 * 检查是否有升级
 */
export const checkUpgrade = () => {
  return new Promise((resolve) => {
    if (process.env.NODE_ENV !== 'production') {
      return resolve(false)
    }
    const storage = getLocalStorage()
    if (storage.getItem(autoRefreshKey)) {
      storage.removeItem(autoRefreshKey)
      window.location.reload()
      return resolve(false)
    }
    const metaElement = document.querySelector('meta[name="version"]') as HTMLMetaElement
    const currentVersion = metaElement ? metaElement.content : ''
    if (currentVersion) {
      /**
       * wkwebview 不支持 service worker 缓存，所以采用自定义版本标识文件来进行更新判断
       */
      axios
        .get<{
          version: string
        }>('./app-manifest.json', {
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then(
          async (res) => {
            if (res.status === 200 && res.data) {
              const version = res.data.version || ''
              if (version && currentVersion !== version) {
                await resetEntryCache()
                return resolve(true)
              }
            }
            resolve(false)
          },
          () => {
            resolve(false)
          }
        )
    } else {
      resolve(false)
    }
  })
}
